/* LIMITA O GRID DA HOME A 4 CARDS */
(function () {
  'use strict';
  var MAX_CARDS = 4;
  var MAX_CARD_WIDTH = 500;

  function isHomePage() {
    var main = document.getElementById('MainContent');
    if (main && main.dataset.template === 'index') return true;
    var path = window.location.pathname.replace(/\/$/, '');
    return path === '' || path === '/';
  }

  function findAllProductCards() {
    var grid = document.querySelector('.bs-product-grid');
    if (!grid) return [];
    var cards = grid.querySelectorAll('.bs-product-card');
    if (!cards.length) return [];
    return Array.prototype.slice.call(cards).filter(function (c) {
      var rect = c.getBoundingClientRect();
      return rect.width > 80 && rect.width < MAX_CARD_WIDTH;
    });
  }

  function limitCards() {
    if (!isHomePage()) return;
    var cards = findAllProductCards();
    if (!cards.length) return;
    cards.forEach(function (card, idx) {
      if (idx < MAX_CARDS) {
        if (card.dataset.hplHidden === '1') { card.style.display = ''; card.removeAttribute('data-hpl-hidden'); }
      } else {
        if (card.dataset.hplHidden !== '1') { card.style.display = 'none'; card.setAttribute('data-hpl-hidden', '1'); }
      }
    });
  }

  function run() { try { limitCards(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  [600, 1800, 4000].forEach(function (ms) { setTimeout(run, ms); });
})();
